import { getMotoristas } from '@spark/services';
import { useState, useEffect, useCallback, useRef } from 'react';
import { notification } from '@spark/ui-components/utils/notification';

export const useMotoristaListagem = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterLoading, setFilterLoading] = useState(false);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const isMountedRef = useRef(true);

  // TanStack Table pagination state
  const [paginationState, setPaginationState] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [filtros, setFiltros] = useState({
    Nome: '',
    Cpf: '',
    CodigoIntegracao: '',
    Tipo: '',
    Ativo: '',
  });

  useEffect(
    () => () => {
      isMountedRef.current = false;
    },
    [],
  );

  const fetchData = useCallback(
    async (filtrosParaBuscar = filtros) => {
      if (!isMountedRef.current) return;

      try {
        setLoading(true);

        const filters = {
          quantidadePorPagina: paginationState.pageSize,
          pagina: paginationState.pageIndex + 1, // TanStack usa 0-indexed, API usa 1-indexed
          ...(filtrosParaBuscar.Nome ? { Nome: filtrosParaBuscar.Nome } : {}),
          ...(filtrosParaBuscar.Cpf ? { Cpf: filtrosParaBuscar.Cpf } : {}),
          ...(filtrosParaBuscar.CodigoIntegracao ? { CodigoIntegracao: filtrosParaBuscar.CodigoIntegracao } : {}),
          ...(filtrosParaBuscar.Tipo !== '' ? { Tipo: filtrosParaBuscar.Tipo } : {}),
          ...(filtrosParaBuscar.Ativo !== '' ? { Ativo: filtrosParaBuscar.Ativo } : {}),
        };

        const response = await getMotoristas(filters);
        if (!isMountedRef.current) return;

        const responseData = response?.data || response;
        const registrosResponse = responseData?.registros ?? responseData?.Registros ?? [];
        const registros = Array.isArray(registrosResponse) ? registrosResponse : [];

        setData(registros);

        const total =
          responseData?.totalRegistros ??
          responseData?.TotalRegistros ??
          registros.length;

        setTotalRegistros(Number(total) || 0);
      } catch (err) {
        console.error('Erro ao buscar motoristas:', err);
        if (isMountedRef.current) {
          notification.error(
            err?.message || 'Erro desconhecido',
            'Erro ao carregar motoristas'
          );
        }
      } finally {
        if (isMountedRef.current) {
          setLoading(false);
        }
      }
    },
    [paginationState.pageIndex, paginationState.pageSize, filtros],
  );

  useEffect(() => {
    fetchData(filtros);
  }, [fetchData]);

  const handleFilterApply = useCallback(
    async (novosFiltros) => {
      if (!isMountedRef.current) return;

      setFilterLoading(true);
      setFiltros(novosFiltros);
      setPaginationState({ pageIndex: 0, pageSize: paginationState.pageSize });

      try {
        await fetchData(novosFiltros);
      } finally {
        if (isMountedRef.current) {
          setFilterLoading(false);
        }
      }
    },
    [fetchData, paginationState.pageSize],
  );

  const handleLimparFiltros = useCallback(() => {
    const filtrosLimpos = {
      Nome: '',
      Cpf: '',
      CodigoIntegracao: '',
      Tipo: '',
      Ativo: '',
    };
    setFiltros(filtrosLimpos);
    setPaginationState({ pageIndex: 0, pageSize: paginationState.pageSize });
    handleFilterApply(filtrosLimpos);
  }, [handleFilterApply, paginationState.pageSize]);

  return {
    data,
    loading,
    filterLoading,
    totalRegistros,
    paginationState,
    setPaginationState,
    handleFilterApply,
    handleLimparFiltros,
  };
};
